import type { FrontendWidget } from '../../types';
import { ThreeColumnLayoutComponent } from './ThreeColumnLayoutComponent';
import type {
  ThreeColumnLayoutConfig,
  ThreeColumnLayoutResolved,
} from './types';

export const threeColumnLayoutWidget: FrontendWidget<
  ThreeColumnLayoutConfig,
  ThreeColumnLayoutResolved
> = {
  componentType: 'layouts.three-column-layout',
  // 70.14: SlotRenderer adds no container — arranges other widgets: the columns are the container its children sit in.
  layout: 'self',
  displayName: 'Three Column Layout',
  defaultValues: {
    leftColumn: [],
    middleColumn: [],
    rightColumn: [],
  },
  ComponentA: ThreeColumnLayoutComponent,
  resolveSync: (config) => config,
};
